import { EInternalNoteType } from '@constants';
import { IInternalNotesFilters } from '@sdk/contracts';
import { Collapse, Checkbox, DatePicker, Flex } from 'antd';
import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { CollapseWrapper, ClearFiltersWrapper, ItemWrapper } from './FiltersItems.styles';

import { Icon } from '@/components/Icon';
import { InternalNoteTypeTag } from '@/components/InternalNotes';
import { useProfile } from '@/store';

type Props = {
  filters?: IInternalNotesFilters;
  filtersCount: number;
  resetFilters: () => void;
  handleSetFilters: (
    key: keyof IInternalNotesFilters,
    value: boolean | string[] | [Dayjs, Dayjs]
  ) => void;
};

export const FiltersItems: React.FC<Props> = ({
  filters,
  filtersCount,
  resetFilters,
  handleSetFilters
}) => {
  const { t } = useTranslation('ChatTranslations');
  const {
    roleCheck: { isTeacher }
  } = useProfile();

  return (
    <CollapseWrapper>
      {!isTeacher && (
        <ItemWrapper>
          <Checkbox
            checked={filters?.isForManagers ?? false}
            onChange={e => handleSetFilters('isForManagers', e.target.checked)}
          />
          <div>{t('HIDDEN_FOR_TEACHERS')}</div>
        </ItemWrapper>
      )}
      <Collapse
        ghost
        bordered={false}
        expandIconPosition="end"
        expandIcon={({ isActive }) => <Icon i={isActive ? 'Subtract' : 'Add'} />}
        items={[
          {
            key: 'type',
            label: t('TAGS'),
            children: (
              <Checkbox.Group value={filters?.type} onChange={e => handleSetFilters('type', e)}>
                <Flex gap={8} vertical>
                  {Object.values(EInternalNoteType).map(type => (
                    <Flex key={type} gap={8} align="center">
                      <Checkbox value={type} />
                      <InternalNoteTypeTag type={type} />
                    </Flex>
                  ))}
                </Flex>
              </Checkbox.Group>
            )
          },
          {
            key: 'createdAt',
            label: t('CREATED_AT'),
            children: (
              <DatePicker.RangePicker
                format="DD/MM/YYYY"
                value={
                  filters?.createdAt
                    ? [dayjs(filters?.createdAt?.[0]), dayjs(filters?.createdAt?.[1])]
                    : undefined
                }
                onChange={e => handleSetFilters('createdAt', e as [Dayjs, Dayjs])}
              />
            )
          },
          {
            key: 'updatedAt',
            label: t('UPDATED_AT'),
            children: (
              <DatePicker.RangePicker
                format="DD/MM/YYYY"
                value={
                  filters?.updatedAt
                    ? [dayjs(filters?.updatedAt?.[0]), dayjs(filters?.updatedAt?.[1])]
                    : undefined
                }
                onChange={e => handleSetFilters('updatedAt', e as [Dayjs, Dayjs])}
              />
            )
          }
        ]}
      />
      {filtersCount > 0 && (
        <ClearFiltersWrapper onClick={resetFilters}>{t('CLEAR_FILTERS')}</ClearFiltersWrapper>
      )}
    </CollapseWrapper>
  );
};
